import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import { getNavLinkClass } from "~/assets/styles/classes/NavLinkClasses";
import {
  BiChevronDown,
  BiChevronUp
} from "react-icons/bi";

export const SubMenu = ({
  titleKey,
  items,
  isOpen,
  toggleOpen
}: {
  titleKey: string;
  items: Array<{ to: string; label: string }>;
  isOpen: boolean;
  toggleOpen: () => void;
}) => {
  const { t } = useTranslation();
  const location = useLocation();


  const isAnyChildActive = items.some((item) => {
    const itemPath = item.to.replace(/\/$/, "");
    const currentPath = location.pathname.replace(/\/$/, "");

    return currentPath === itemPath || currentPath.startsWith(itemPath + "/");
  });

  return (
    <li className="mb-2">
      <div
        className={`flex items-center justify-between px-4 py-2 rounded-md transition-all border
          border-transparent text-white
          ${
            isAnyChildActive
              ? "bg-opacity-10 bg-[#51E7F9] border-[#51E7F9] border-[1px] text-[#51E7F9]"
              : "hover:border-[#51E7F9] hover:bg-opacity-10 hover:bg-[#51E7F9] hover:border-[1px] hover:text-[#51E7F9]"
          }`}
      >
        <span className="text-sm font-semibold flex-1 text-[14px] leading-[16px]">
          {t(titleKey)}
        </span>

        <button onClick={toggleOpen} className="ml-2">
          {isOpen ? (
            <BiChevronUp size={18} className="text-[#51E7F9]" />
          ) : (
            <BiChevronDown size={18} className="text-[#51E7F9]" />
          )}
        </button>
      </div>

      {isOpen && (
        <ul className="ml-6 mt-2 space-y-2">
          {items.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                end
                className={({ isActive }) => getNavLinkClass(isActive)}
              >
                <span>{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};
